// pages/api/pending.ts
import type { NextApiRequest, NextApiResponse } from "next";

export default async function handler(req: NextApiRequest, res: NextApiResponse) {
  try {
    const response = await fetch("http://94.72.111.23:2000/myritewallet/v1/WEALTH/PENDING", {
      method: "GET",
      headers: { accept: "application/json" },
    });

    if (!response.ok) {
      return res.status(response.status).json({ error: "Backend request failed" });
    }

    const data = await response.json();
    res.status(200).json(data);
  } catch (error) {
    res.status(500).json({ error: "Failed to fetch backend" });
  }
}
